import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import dayjs, { Dayjs } from "dayjs";

interface BookingFiltersState {
  bookingDateFrom: Dayjs | null;
  startRange: Dayjs | null;
  endRange: Dayjs | null;
  memberShipType: string;
  categoryId: string;
  bookingStatus: string;
  subcategoryId: string;
  numberofGuest: string;
  employeeId: string[];
  userId: string[];
  isTodayBooking: boolean;
  bookingNumberofDays: boolean;
}

const initialState: BookingFiltersState = {
  bookingDateFrom: null,
  startRange: null,
  endRange: null,
  memberShipType: "",
  categoryId: "",
  bookingStatus: "",
  subcategoryId: "",
  numberofGuest: "",
  employeeId: [],
  userId: [],
  isTodayBooking: false,
  bookingNumberofDays: false,
};

// Load from localStorage if exists
const savedFilters = localStorage.getItem("bookingFilters");
const persistedState = savedFilters
  ? {
      ...initialState,
      ...JSON.parse(savedFilters),
      // Convert ISO strings back to Dayjs
      startRange: JSON.parse(savedFilters)?.startRange
        ? dayjs(JSON.parse(savedFilters)?.startRange)
        : null,
      endRange: JSON.parse(savedFilters)?.endRange
        ? dayjs(JSON.parse(savedFilters)?.endRange)
        : null,
      bookingDateFrom: JSON.parse(savedFilters)?.bookingDateFrom
        ? dayjs(JSON.parse(savedFilters)?.bookingDateFrom)
        : null,
    }
  : initialState;

const bookingFiltersSlice = createSlice({
  name: "bookingFilters",
  initialState: persistedState,
  reducers: {
    setBookingFilters(
      state,
      action: PayloadAction<Partial<BookingFiltersState>>
    ) {
      Object.assign(state, action.payload);
      localStorage.setItem("bookingFilters", JSON.stringify(state));
    },
    resetBookingFilters() {
      localStorage.removeItem("bookingFilters");
      return initialState;
    },
  },
});

export const { setBookingFilters, resetBookingFilters } =
  bookingFiltersSlice.actions;

export default bookingFiltersSlice.reducer;
